/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* istanbul ignore file */
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
// import LanguageStrings from '../../../i18n/locales'

// const AddGatewayStrings = LanguageStrings().GatewayManagementCollectionStrings.AddGatewayComponent

const ZUpdateGatewayApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface UpdateGatewayPutRequest {
  type?: string
  id?: string
  name: string
  description: string
  ip_address: string
  port: string
  gateway_type_id?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateGatewayApiResponse,
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type UpdateGatewayApiResponse = z.infer<typeof ZUpdateGatewayApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateGateway (
  updateGatewayPutRequest: UpdateGatewayPutRequest,
  onSuccess: (successResponse: UpdateGatewayApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .put(url, updateGatewayPutRequest, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
